import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { Active, ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, FormTypeAdd, GuidDefault, PageSize, PageTypeCount, PageTypeGetPaged, PaginationBack, PaginationFirst, PaginationLast, PaginationNext } from "utils/Constant";
import { ApiDeletePayment, ApiDeleteTenant, ApiGetBookingList, ApiGetCashflow, ApiGetPaymentList, ApiGetSystemSettingById, ApiGetTenantList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import moment from "moment";
import { money } from "utils/helpers";

export default function Cashflow(){
    let navigate = useNavigate()
    
    const { data: cashflowData, fetch: getCashflow } = useFetch(ApiGetCashflow)

    const { data: paymentList, fetch: getPaymentList } = useFetch(ApiGetPaymentList)
    const { fetch: getPaymentCount } = useFetch(ApiGetPaymentList)
    const { fetch: deletePayment } = useFetch(ApiDeletePayment)

    const { fetch: getStatusList } = useFetch(ApiGetSystemSettingById)
    const { fetch: getMonthList } = useFetch(ApiGetSystemSettingById)
    const { fetch: getYearList } = useFetch(ApiGetSystemSettingById)

    const [paymentCode, setPaymentCode] = useState(EmptyString)
    const [tenantName, setTenantName] = useState(EmptyString)
    const [roomNumber, setRoomNumber] = useState(EmptyString)
    const [accMonth, setAccMonth] = useState(EmptyString)
    const [accYear, setAccYear] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)

    // Dropdown
    const [statusOptions, setStatusOptions] = useState([])
    const [accMonthOptions, setAccMonthOptions] = useState([])
    const [accYearOptions, setAccYearOptions] = useState([])

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        // setLoading(true)

        Promise.all([
            fGetStatusList(),
        ]).then(() => {
            Promise.all([
                fGetMonthList()
            ]).then(() => {
                Promise.all([
                    fGetYearList()
                ]).then(() => {
                    setAccMonth(moment(new Date()).format("M"))
                    setAccYear(moment(new Date()).format("yyyy"))
                    fBindGrid(0)
                })
            }).finally(() => {
                
            })
        }).finally(() => {
            setLoading(false)
        })
    },[])

    useEffect(() => {
        setLoading(true)

        Promise.all([
            fGetCashflow()
        ]).then(() => {
            setLoading(false)
        })
    },[accYear])

    // Function Button
    function fEditBtnClick(paymentId){
        navigate("/kost/payment/form?paymentId=" + paymentId + "&formType=Edit")
    }
    function fDeleteBtnClick(paymentId){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading(true)
                    Promise.all([
                        fDeletePayment(paymentId)
                    ]).then(() => {
                        setLoading(false)
                    })
                    
                }
            }
        })
    }
    function fSearchBtnClick(){
        fBindGrid(0)
    }

    // Function Api Call
    async function fGetCashflow(){
        await getCashflow({
            data: {
                kostId: localStorage.getItem("KostId"),
                accYear: accYear === "" ? moment(new Date()).format("yyyy") : accYear
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
        })
    }

    async function fGetPaymentList(index){
        await getPaymentList({
            data: {
                kostId: localStorage.getItem("KostId"),
                paymentCode: paymentCode,
                tenantName: tenantName,
                roomNumber: roomNumber,
                accMonth: accMonth === EmptyString ? moment(new Date()).format("M") : accMonth,
                accYear: accYear === EmptyString ? moment(new Date()).format("yyyy") : accYear, 
                status: status === EmptyString ? '1' : status,
                pageSize: PageSize,
                pageIndex: parseInt(index),
                pageType: PageTypeGetPaged,
                sortBy: "A.PaymentDate",
                sortOrder: "DESC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
        })
    }
    async function fGetPaymentCount(){
        let dataCount = 0

        await getPaymentCount({
            data: {
                kostId: localStorage.getItem("KostId"),
                paymentCode: paymentCode,
                tenantName: tenantName,
                roomNumber: roomNumber,
                accMonth: accMonth === EmptyString ? moment(new Date()).format("M") : accMonth,
                accYear: accYear === EmptyString ? moment(new Date()).format("yyyy") : accYear, 
                status: status === EmptyString ? '1' : status,
                pageSize: PageSize,
                pageIndex: 0,
                pageType: PageTypeCount,
                sortBy: "A.PaymentDate",
                sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                dataCount = response.data.dataCount
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return dataCount
    }
    async function fDeletePayment(paymentId){
        await deletePayment({
            data: {
                kostId: localStorage.getItem("KostId"),
                paymentId: paymentId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { setSuccessModal({  isOpen: false }) }} })
                fBindGrid(0)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetStatusList(){
        await getStatusList({
            data: {
                kostId: GuidDefault,
                systemId: "Status"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].systemText, value: response.data[i].systemValue })
                }

                setStatusOptions(tempArray)
                setStatus(tempArray[0].value)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetMonthList(){
        await getMonthList({
            data: {
                kostId: GuidDefault,
                systemId: "Month"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].systemText, value: response.data[i].systemValue })
                }

                setAccMonthOptions(tempArray)
                setAccMonth(tempArray[0].value)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetYearList(){
        await getYearList({
            data: {
                kostId: GuidDefault,
                systemId: "Year"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let tempArray = []

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].systemText, value: response.data[i].systemValue })
                }

                setAccYearOptions(tempArray)
                setAccYear(tempArray[0].value)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading(true)

        let totalData = await fGetPaymentCount()

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        Promise.all([
            fSetPaginationOptions(totalData, index)
        ]).then(() => {
            fGetPaymentList(i)
        }).finally(() => {
            setLoading(false)
        })        
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    function fGetStatus(statusCode){
        let status = EmptyString
        
        for (let i = 0; i < statusOptions.length; i++){
            if (statusOptions[i].value === statusCode){
                status = statusOptions[i].label
            }
        }

        return status
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    return(
        <div className="flex flex-col gap-2">
            <div>
                <span className="font-semibold text-2xl">Cashflow</span>
            </div>
            
            <hr />

            <div className="flex items-center gap-4 mt-4">
                <span>Year</span>
                <div className="w-[200px]">
                    <Dropdown options={ accYearOptions } value={ accYear } onChange={(e) => { setAccYear(e.value) }} />
                </div>                
            </div>

            <div className="flex flex-wrap gap-3 mt-4">
                { cashflowData?.data?.cashflow?.map((data, i) => {
                    return(
                        <div className="border rounded-md w-[400px] p-4 flex flex-col gap-3" key={i}>
                            <div>
                                <span className="font-semibold text-2xl">{ data.month }</span>
                            </div>
                            <div className="flex flex-col gap-2">
                                <div className="flex">
                                    <div className="w-5/12">
                                        <span>Gross Income</span>
                                    </div>
                                    <div className="px-2">
                                        <span>:</span>
                                    </div>
                                    <div>                        
                                        <span>Rp { money(data.grossAmount) }</span>
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="w-5/12">
                                        <span>Expense</span>
                                    </div>
                                    <div className="px-2">
                                        <span>:</span>
                                    </div>
                                    <div>                        
                                        <span>Rp { money(data.expense) }</span>
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="w-5/12">
                                        <span>Net Income</span>
                                    </div>
                                    <div className="px-2">
                                        <span>:</span>
                                    </div>
                                    <div>                        
                                        <span>{ data.grossAmount < data.expense ? "-" : "" }  Rp { money(data.netAmount) }</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }) }
                
            </div>

            {/* Filter */}
            {/* <div className="flex gap-5 justify-between mt-5">
                <div className="flex gap-4 w-full">
                    <div className="flex flex-col gap-2 w-full">
                        <span>Payment Code</span>
                        <input className="input" value={ paymentCode } onChange={(e) => { setPaymentCode(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>Tenant Name</span>
                        <input className="input" value={ tenantName } onChange={(e) => { setTenantName(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>Room Number</span>
                        <input className="input" value={ roomNumber } onChange={(e) => { setRoomNumber(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                    </div>
                    <div className="flex flex-col gap-2 w-full">
                        <span>Payment Periode</span>
                        <div className="flex gap-2">
                            <Dropdown className="w-full" value={ accMonth } options={ accMonthOptions } onChange={(e) => { setAccMonth(e.value) }} />
                            <Dropdown className="w-32" value={ accYear } options={ accYearOptions } onChange={(e) => { setAccYear(e.value) }} />
                        </div>
                    </div>
                    
                    <div className="flex flex-col gap-2 w-full">
                        <span>Status</span>
                        <Dropdown value={ status } options={ statusOptions } onChange={(e) => { setStatus(e.value) }} />
                    </div>
                </div>
                <div>
                    <div className="flex items-end h-full">
                        <SearchButton onClick={() => { fSearchBtnClick() }} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={() => { navigate("/kost/payment/form?paymentId=&formType=" + FormTypeAdd) }} />
            </div> */}
           
            {/* Data */}
            {/* <div className="mt-5">
                <table className="w-full border">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Payment Code</th>
                            <th className="font-semibold text-left px-2">Payment Date</th>
                            <th className="font-semibold text-left px-2">Payment Period</th>
                            <th className="font-semibold text-left px-2">Tenant Name</th>
                            <th className="font-semibold text-left px-2">Room Number</th>
                            <th className="font-semibold text-left px-2">Amount</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {paymentList?.data?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.paymentCode }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ moment(data.paymentDate).format("DD MMM yyyy") }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.accMonth + ' ' + data.accYear }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.tenantName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.roomNumber }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>Rp { money(data.amount) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.status }</span>
                                    </td>
                                    <td className="flex justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => fEditBtnClick( data.paymentId )}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === Active ? "block" : "hinnden" }`} onClick={() => fDeleteBtnClick( data.paymentId )}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            /> */}

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}